import { ButtonBase } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Chip = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(({ theme, active }) => {
  const isDark = theme.palette.mode === "dark";
  const { text, background, divider, gold, grey } = theme.palette;

  return {
    gap: theme.spacing(0.625),
    height: 32,
    padding: theme.spacing(0, 1.5),
    borderRadius: 999,
    border: `1px solid ${active ? text.primary : divider}`,
    backgroundColor: active ? text.primary : background.paper,
    color: active ? background.paper : text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: "nowrap",
    flexShrink: 0,
    transition: theme.transitions.create(
      ["background-color", "border-color", "color"],
      { duration: 150 }
    ),

    "& svg": {
      fontSize: 17,
      color: active ? (isDark ? gold.dark : gold.main) : text.secondary,
    },

    "&:hover": {
      backgroundColor: active
        ? alpha(text.primary, 0.85)
        : grey[isDark ? 900 : 100],
    },
  };
});

export const Count = styled("span")({
  opacity: 0.7,
});
